<template>
  <div class="chatList">
    <h2 class="title-area">
      <span class="main-title">咨询列表</span>
    </h2>
    <div class="search">
      <el-date-picker
        v-bind="{
          value: date,
          'range-separator': '-',
          type: 'datetimerange',
          'start-placeholder': '开始时间',
          'end-placeholder': '结束时间',
          'value-format': 'yyyy-MM-dd HH:mm:ss',
          'default-time': ['00:00:00', '23:59:59'],
          clearable: false,
          'popper-class': 'chatList-date-picker'
        }"
        :picker-options="pickerOptions"
        @input="val => (date = val)"
        @focus="resetDate"
      ></el-date-picker>
      <el-button type="primary" @click="onSearch">查询</el-button>
    </div>
    <div v-if="list && list.length > 0" class="list-content" v-infinite-scroll="loadMore">
      <div class="chatList__content" ref="wrapper">
        <router-link
          class="chatList__lay"
          v-for="(item, i) in list"
          :key="item.advisoryId"
          :to="`/chatHome/${item.advisoryId}?status=${i !== 0 ? 'history' : 'current'}`"
        >
          <img :src="item.doctorAvatarUrl || require('@/assets/img/icon_default_doctor_avatar.png')" alt="" />
          <div class="chatList__info">
            <span class="chatList__title">
              {{ item.groupTitle }}
            </span>
            <span class="chatList__describe">{{ item.chatText || '您有一条新消息' }}</span>
          </div>
          <span class="chatList__time">{{ item.createTime | parseTime(true) }}</span>
        </router-link>
      </div>
    </div>
    <div v-else class="empty"></div>
    <!-- <direction></direction> -->
  </div>
</template>
<script>
import Constant from '@/lib/constant';
// import direction from '@/components/global/direction/index';
import watermark from '@/util/watermark';
import dayjs from 'dayjs';

let dateSpot = null;

export default {
  data() {
    return {
      totalCount: 0,
      currentPage: 1,
      list: [],
      loadStatus: 0,
      date: [dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'), dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
    };
  },
  computed: {
    pickerOptions() {
      dateSpot = null;

      return {
        onPick: ({ minDate, maxDate }) => {
          if (!maxDate) {
            dateSpot = minDate;
          }
        },
        disabledDate: time => {
          if (!dateSpot) return false;
          const start = +dayjs(dateSpot).startOf('month').format('x');
          const end = +dayjs(dateSpot).endOf('month').format('x');
          return time.getTime() < start || time.getTime() > end;
        }
      };
    }
  },
  watch: {},
  created() {
    this.loadMore();
  },
  mounted() {
    const { userName, companyName } = this.$store.getters;
    watermark.set(`${companyName} ${userName},隐私信息严禁截屏打印`, this.$refs.wrapper);
  },
  beforeRouteLeave(to, from, next) {
    watermark.remove(this.$refs.wrapper);
    next();
  },
  methods: {
    resetDate() {
      dateSpot = null;
    },
    onSearch() {
      this.currentPage = 1;
      this.loadStatus = 0;
      this.list = [];
      this.loadMore();
    },
    async loadMore() {
      if (this.loadStatus) return;
      this.loadStatus = 1;
      const params = {
        pageNo: this.currentPage,
        pageSize: Constant.pageSize,
        createTimeStart: +new Date(this.date[0]),
        createTimeEnd: +new Date(this.date[1])
      };
      try {
        const data = await Fetch.getAdvisoryList(params);
        ++this.currentPage;
        this.loadStatus = data.list.length < Constant.pageSize ? 2 : 0;
        this.list.push(...data.list);
      } catch (error) {
        this.loadStatus = 0;
      }
    },
    notify() {
      // 先检查浏览器是否支持
      if (!('Notification' in window)) return;
      // 检查用户是否同意接受通知
      if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        const notification = new Notification('您有新的消息，请查收！');
        // 否则我们需要向用户获取权限
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          // 如果用户同意，就可以向他们发送通知
          if (permission === 'granted') {
            const notification = new Notification('您有新的消息，请查收！');
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.chatList {
  width: 100%;
  height: auto;
  .list-content {
    position: relative;
    width: 100%;
    height: calc(100vh - 136px);
    overflow: hidden;
    overflow-y: auto;
  }
  .chatList__content {
    width: 100%;
    height: auto;
    padding: 20px;
    background: #fff;
    border: 1px solid #f2f2f2;
    box-shadow: 0 4px 12px 0 #ededed;
    border-radius: 4px;
    .chatList__lay {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #eaeaea;
      cursor: pointer;
      > img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
      .chatList__info {
        margin: 0 10px;
        flex: 1;
        .chatList__title {
          display: block;
          color: #333;
          font-size: 16px;
          position: relative;
          display: inline-block;
        }
        .chatList__describe {
          color: #666;
          font-size: 12px;
          display: block;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .chatList__time {
        color: #999;
        font-size: 14px;
      }
    }
  }

  .empty {
    width: 100%;
    height: 452px;
    background-size: 272px;
    background-color: #fff;
    background-position: center center;
    background-image: url('~@/assets/img/empty.jpg');
    background-repeat: no-repeat;
  }
}

.search {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
</style>

<style lang="scss">
.chatList-date-picker {
  .el-picker-panel__footer {
    .el-button--text {
      display: none;
    }
  }
}
</style>
